import styled from "styled-components/macro";
import { SHINY_ANIMATED, TILE_WIDTH_PX_LG } from "../../../constants/constants";
import { GroupTileStyles } from "./GroupTile/GroupTileStyles";
import { Button } from "@mui/material";
import { useSettings } from "contexts/SettingsManager/SettingsManager";
import { useIsDarkMode } from "store/atoms";
import { darkModeModalBackgroundColor } from "constants/colors";

const TileLoaderSkeletonStyles = styled.div<{
  $backgroundColor: string;
  $tileWidth?: number;
  $isLargeTiles: boolean;
}>`
  pointer-events: none;
  cursor: default;
  display: flex;
  justify-content: center;
  .group-tile {
    box-sizing: border-box;
    background: ${({ $backgroundColor }) => $backgroundColor} !important;
    border: 1px solid ${({ $backgroundColor }) => $backgroundColor} !important;
    position: relative; /* Shine */
    background: ${({ $backgroundColor }) => $backgroundColor};
    ${SHINY_ANIMATED}
  }
`;

interface TileLoaderSkeletonProps {
  tileWidth?: number;
  isLargeTiles?: boolean;
}

export default function TileLoaderSkeleton({
  tileWidth = TILE_WIDTH_PX_LG,
  isLargeTiles: propIsLargeTiles,
}: TileLoaderSkeletonProps) {
  const { isLargeTiles: settingsIsLargeTiles } = useSettings();
  const isLargeTiles =
    propIsLargeTiles !== undefined ? propIsLargeTiles : settingsIsLargeTiles;

  const [isDarkMode] = useIsDarkMode();
  const backgroundColor = isDarkMode
    ? darkModeModalBackgroundColor
    : "hsl(0, 0%, 93%)";
  return (
    <TileLoaderSkeletonStyles
      className="groupTiles loading"
      $backgroundColor={backgroundColor}
      $tileWidth={tileWidth}
      $isLargeTiles={isLargeTiles}
    >
      <div className="tile-container">
        <GroupTileStyles
          $isLargeTiles={isLargeTiles}
          $tileWidth={tileWidth}
          $isDarkMode={isDarkMode}
        >
          <Button>
            <div className="group-tile loading" />
          </Button>
        </GroupTileStyles>
      </div>
    </TileLoaderSkeletonStyles>
  );
}
